export const CLASSIC_RETIREMENT_DATE = '30 September 2026';
